var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 92,
    viewBox: "0 0 96 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Question"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    opacity: 0.68,
    filter: "url(#filter0_f_69_1719)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 48,
    height: 44,
    rx: 22,
    fill: "#141522",
    fillOpacity: 0.07,
    style: {
      fill: "#141522",
      fill: "color(display-p3 0.0784 0.0824 0.1333)",
      fillOpacity: 0.07
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Bg",
    x: 24.5,
    y: 27.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#3674CB",
    stroke: "white",
    style: {
      fill: "#3674CB",
      fill: "color(display-p3 0.2118 0.4549 0.7961)",
      fillOpacity: 1,
      stroke: "white",
      stroke: "white",
      strokeOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_69_1719",
    x: 0,
    y: 0,
    width: 96,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_69_1719"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/Question.ab22048486dbf9c00226fc78a7508b87.svg";
export { ForwardRef as ReactComponent };